<template>
  <div class="flex flex-col justify-center items-center">
    <div class="flex items-center">
      <Icon name="remove" height="20" class="mt-1" />
      <a-slider
        v-model="sliderValue"
        :min="0"
        :max="15"
        :default-value="1"
        @afterChange="handleBoardZoom"
        class="w-32"
      />
      <Icon name="add" height="20" class="mt-1" />
    </div>
    <overlay v-if="loading" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Icon from "@/components/Icon.vue";
import { debounce } from "@/use/useTimeout";
import Overlay from "@/components/Overlay.vue";
import { useBoardStore } from "@/store/board/BoardStore";
import { useBrickStore } from "@/store/brick/BrickStore";
import { useFleetStore } from "@/store/fleet/FleetStore";

export default defineComponent({
  components: { Icon, Overlay },
  setup() {
    const boardStore = useBoardStore();
    const brickStore = useBrickStore();
    const fleetStore = useFleetStore();

    const loading = ref(false);
    const sliderValue = ref(1);

    const debounceBrickSizeAdjustment = debounce(async function () {
      await brickStore.adjustBrickSizes();
      await fleetStore.updateFleetOccupancy();
      loading.value = false;
    }, 300);

    const handleBoardZoom = (sliderValue): void => {
      loading.value = true;
      boardStore.setZoomLevel(sliderValue);
      boardStore.setBoard();
      debounceBrickSizeAdjustment();
    };

    const initZoomLevel = () => {
      //check localstorage for zoomLevel and update zoom
      const zoomLevel = boardStore.zoomLevel;
      sliderValue.value = zoomLevel;
      handleBoardZoom(zoomLevel);
    };

    onMounted(() => {
      initZoomLevel();
    });
    return { loading, handleBoardZoom, sliderValue };
  }
});
</script>

<style scoped></style>
